export default {
  description:   'O arquivo estará disponível para download por 7 dias, após esse período ele será removido desse página',
  generic_error: 'Tivemos um problema ao processar o seu pedido, por favor, tente novamente mais tarde ou entre em contato com a nossa central de atendimento',
  button_text:   'Clique aqui para fazer o download dos seus dados',
};
